export default __webpack_public_path__ + "static/cloudator-brochure-2fa03853049d283133c9e9fdf4f8a9b5.jpg";